import { useState, useEffect } from "react";
import { RecoveryKeyModal } from "./RecoveryKeyModal";
import { LoginFormComponent } from "./LoginFormComponent";
import { RecoverFormComponent } from "./RecoverFormComponent";

interface LoginScreenProps {
  readonly onLogin: () => void;
  readonly initialMode?: "login" | "register";
}

type AuthMode = "login" | "register" | "recover";

export function LoginScreen({ onLogin, initialMode = "login" }: LoginScreenProps) {
  const [mode, setMode] = useState<AuthMode>(initialMode);
  const [recoverEmail, setRecoverEmail] = useState("");
  const [pendingRecoveryKey, setPendingRecoveryKey] = useState<string | null>(null);

  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => {
      meta.remove();
    };
  }, []);

  if (mode === "recover") {
    return (
      <RecoverFormComponent
        onBack={() => setMode("login")}
        onSuccess={() => {
          setPendingRecoveryKey(null);
          setMode("login");
          onLogin();
        }}
        initialEmail={recoverEmail}
      />
    );
  }

  if (pendingRecoveryKey) {
    return <RecoveryKeyModal recoveryKey={pendingRecoveryKey} onAcknowledge={onLogin} />;
  }

  const handleModeChange = () => {
    const next = mode === "login" ? "register" : "login";
    setMode(next);
  };

  return (
    <LoginFormComponent
      mode={mode as "login" | "register"}
      onModeChange={handleModeChange}
      onSuccess={(recoveryKey?: string) => {
        if (recoveryKey) {
          setPendingRecoveryKey(recoveryKey);
        } else {
          onLogin();
        }
      }}
      onRecover={(email) => {
        setRecoverEmail(email);
        setMode("recover");
      }}
    />
  );
}
